import { CreditsPerMonth, CreditsPerYear } from 'constants/credits';
import React, { useRef } from 'react';
import {
    DarkMode,
    Flex,
    InfoOutlined,
    Popover,
    useBreakpoint,
} from '@landr/maestro';
import { Interval } from 'types/generated/subscriptionsApi';
import { Trans } from '@lingui/macro';
import Plan from '../Plan/Plan';
import { StyledLi } from '../../styled';
import { useUpsellActionsContext } from '../../context/UpsellActionsContext';
import useSamplePlan from './useSamplePlan';

const SampleUsp = ({
    frequency,
    isMobile,
}: {
    frequency: Interval;
    isMobile: boolean;
}) => {
    const popOverAnchorRef = useRef<HTMLDivElement>(null);

    return (
        <ul>
            <li className={StyledLi}>
                {frequency === 'Monthly' ? (
                    <Trans>{CreditsPerMonth} credits per month</Trans>
                ) : (
                    <Trans>{CreditsPerYear} credits per year</Trans>
                )}
            </li>
            <li className={StyledLi}>
                <Trans>Weekly pack giveaway</Trans>
            </li>

            <li className={StyledLi}>
                <Flex alignItems="center" display="inline-flex">
                    <Trans>Unlimited access to Chromatic</Trans>

                    <Flex
                        alignItems="center"
                        ref={popOverAnchorRef}
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                    >
                        <DarkMode>
                            <Popover
                                hasArrow
                                placement="top"
                                triggerEvent={isMobile ? 'click' : 'hover'}
                                anchorRef={popOverAnchorRef}
                            >
                                <Popover.Trigger>
                                    <InfoOutlined color="icon.low" size="sm" />
                                </Popover.Trigger>
                                <Popover.Content>
                                    <Trans>Loop-based instrument.</Trans>
                                </Popover.Content>
                            </Popover>
                        </DarkMode>
                    </Flex>
                </Flex>
            </li>
        </ul>
    );
};

const SamplePlan = () => {
    const isMobile = useBreakpoint('md');
    const isVerticalLayout = useBreakpoint('lg');

    const {
        frequency,
        hasSamplesPlan,
        samplesCatalog,
        selectedPlan,
        handlePlanSelect,
        getDiscountedPlan,
    } = useUpsellActionsContext();

    const {
        code,
        currency,
        info,
        monthlyEquivalentPrice,
        monthlyEquivalentSale,
        salePrice,
        subscriptionPrice,
        title,
    } = useSamplePlan({
        frequency,
        hasSamplesPlan,
        samplesCatalog,
        getDiscountedPlan,
    });

    return (
        <Plan
            code={code}
            currency={currency}
            frequency={frequency}
            handlePlanSelect={handlePlanSelect}
            info={info}
            isChecked={selectedPlan === code}
            isVerticalLayout={isVerticalLayout}
            monthlyEquivalentPrice={monthlyEquivalentPrice}
            monthlyEquivalentSale={monthlyEquivalentSale}
            salePrice={salePrice}
            subscriptionPrice={subscriptionPrice}
            title={title}
            usp={<SampleUsp frequency={frequency} isMobile={isMobile} />}
        />
    );
};

export default SamplePlan;
